import { render } from "./emailNotice.vue?vue&type=template&id=8befefaa&scoped=true"
import script from "./emailNotice.vue?vue&type=script&lang=js"
export * from "./emailNotice.vue?vue&type=script&lang=js"

import "./emailNotice.vue?vue&type=style&index=0&id=8befefaa&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8befefaa"]])

export default __exports__